@if (isOpen()) {
  <ai-iqboost-chat-dialog
    [scope]="scope()"
    [scopeLabel]="scopeLabel()"
    [subtitle]="subtitleKey() | translate"
    [placeholder]="placeholderKey() | translate"
    [prompts]="prompts()"
    [promptsLoading]="loadingPrompts()"
    [autoAsk]="autoAsk()"
    [(richUi)]="richUi"
    (closed)="isOpen.set(false)"
    (entityOpened)="actionCompleted.emit($event)"
  ></ai-iqboost-chat-dialog>
}
